const profileTypes = {
  MATRIMONIO: 1,
  MAMA: 2,
  ASESOR: 3,
  IOSEF: 4,
  JUVENIL: 5
}
const profileTypeLabels = {
  [profileTypes.MATRIMONIO]: 'Matrimonio',
  [profileTypes.MAMA]: 'Mamá',
  [profileTypes.ASESOR]: 'Asesor',
  [profileTypes.IOSEF]: 'Iosef',
  [profileTypes.JUVENIL]: 'Misión Juvenil'
}

export {
  profileTypes,
  profileTypeLabels
};
